export const isAnalyticsEnabled = !process.env.GATSBY_DISABLE_ANALYTICS